import * as api from "@/api/stationLibrary.api";

export const getLibrary = async ({ commit }, stationKey) => {
  try {
    let library = await api.getLibrary(stationKey);

    commit("setLibrary", library);

    return library;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getMediaByRef = async (
  { commit, dispatch, rootGetters },
  start = 0
) => {
  try {
    let tracks = rootGetters["Autodj/tracks"];

    let chunkSize = 100;
    let end = start + chunkSize;

    let trackChunk = tracks.slice(start, end);

    let playlistMedia = await api.getMediaByRef(trackChunk);

    commit("setPlaylistMedia", playlistMedia);

    if (end < tracks.length) {
      dispatch("getMediaByRef", end);
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const uploadMediaFile = async (vuex, file) => {
  try {
    return await api.uploadMediaFile(file);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getMediaUploadingStatus = async (vuex, task) => {
  try {
    return await api.getMediaUploadingStatus(task);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateMedia = async (vuex, media) => {
  try {
    return await api.updateMedia(media);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const addToUploadingList = async ({ commit }, mediaList) => {
  try {
    commit("setUploadingMediaList", mediaList);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const removeFromUploadingList = async ({ commit }, index) => {
  try {
    commit("removeFromUploadingList", index);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const uploadMediaList = async ({ commit, getters, dispatch }) => {
  commit("setUploadProcessing", true);

  for (let index = 0; index < getters.uploadingMediaList.length; index++) {
    const media = getters.uploadingMediaList[index];

    commit("setUploadingMedia", {
      index: index,
      attributes: [
        { key: "status", value: "loading" },
        { key: "progress", value: 0 },
      ],
    });

    try {
      const response = await dispatch("uploadMediaFile", media.file);

      commit("setUploadingMedia", {
        index: index,
        attributes: [
          { key: "status", value: response.status.toLowerCase() },
          { key: "task", value: response.task_id },
        ],
      });

      setTimeout(() => {
        dispatch("checkMediaUploadingStatus", index);
      }, 1000);
    } catch (e) {
      console.log(e);

      commit("setUploadingMedia", {
        index: index,
        attributes: [
          { key: "status", value: "error" },
          { key: "progress", value: null },
        ],
      });
    }
  }

  if (getters.uploadingCompleted) {
    commit("setUploadProcessing", false);
  }
};

export const checkMediaUploadingStatus = async (
  { commit, dispatch, getters },
  index
) => {
  const media = getters.uploadingMediaList[index];

  try {
    const response = await dispatch("getMediaUploadingStatus", media.task);

    const status = response.status.toLowerCase();

    commit("setUploadingMedia", {
      index: index,
      attributes: [
        { key: "status", value: status },
        { key: "progress", value: response.progress ? response.progress : 0 },
      ],
    });

    if (status === "success") {
      commit("setUploadingMedia", {
        index: index,
        attributes: [{ key: "data", value: response.data }],
      });
    } else if (status === "pending" || status === "processing") {
      setTimeout(() => {
        dispatch("checkMediaUploadingStatus", index);
      }, 1000);
    }
  } catch (e) {
    console.log(e);

    commit("setUploadingMedia", {
      index: index,
      attributes: [
        { key: "status", value: "error" },
        { key: "progress", value: null },
      ],
    });
  }

  if (getters.uploadingCompleted) {
    commit("setUploadProcessing", false);
  }
};

export const resetUploader = async ({ commit }) => {
  try {
    commit("setUploadingMediaList", []);
    commit("setUploadProcessing", null);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const resetLibrary = async ({ commit }) => {
  try {
    commit("reset");
  } catch (e) {
    console.log(e);
    throw e;
  }
};
